module.exports = __webpack_public_path__ + "static/elex-315-8e1e329f1d8e0d8d18fb12a0e600385a.png";